(() => {
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');
  const productRootSelector = '[data-section-type="product"]';
  const promoPattern = /buy\s*5\s*socks\s*get\s*the\s*6th\s*free/i;
  const shippingPattern = /away\s*from\s*free\s*shipping/i;
  const originMarkers = new WeakMap();
  let frameRequested = false;

  function findCampaign(root, pattern) {
    return Array.from(root.querySelectorAll('.popmechanic-js-container')).find((element) =>
      pattern.test(element.textContent || '')
    );
  }

  function rememberOrigin(element) {
    if (originMarkers.has(element) || !element.parentNode) return;

    const marker = document.createComment('mobile-pdp-widget-origin');
    element.parentNode.insertBefore(marker, element);
    originMarkers.set(element, marker);
  }

  function restoreOrigin(element) {
    const marker = originMarkers.get(element);
    if (!marker || !marker.parentNode) return;

    marker.parentNode.insertBefore(element, marker.nextSibling);
    marker.remove();
    originMarkers.delete(element);
  }

  function placeWidgets() {
    frameRequested = false;

    document.querySelectorAll(productRootSelector).forEach((root) => {
      const promo = findCampaign(root, promoPattern);
      const progressText = root.querySelector('.popmechanic-progress-text');
      const shippingProgress =
        (progressText && progressText.closest('.popmechanic-js-container')) || findCampaign(root, shippingPattern);
      const promoSlot = root.querySelector('[data-mobile-pdp-promo-slot]');
      const addToCartButton = root.querySelector('[data-add-to-cart]');
      const productForm = addToCartButton && addToCartButton.closest('form');
      const purchaseRow = productForm && productForm.querySelector('.large-row');

      if (mobileQuery.matches) {
        if (promo && promoSlot && promo.parentElement !== promoSlot) {
          rememberOrigin(promo);
          promoSlot.appendChild(promo);
        }

        if (shippingProgress && purchaseRow && shippingProgress.previousElementSibling !== purchaseRow) {
          rememberOrigin(shippingProgress);
          purchaseRow.insertAdjacentElement('afterend', shippingProgress);
        }
      } else {
        if (promo) restoreOrigin(promo);
        if (shippingProgress) restoreOrigin(shippingProgress);
      }
    });
  }

  function schedulePlacement() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(placeWidgets);
  }

  const observer = new MutationObserver(schedulePlacement);

  function init() {
    placeWidgets();
    observer.observe(document.body, { childList: true, subtree: true });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', schedulePlacement);
    } else {
      mobileQuery.addListener(schedulePlacement);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
